import React, {Component} from 'react';
import PropTypes from 'prop-types';

class ErrorAlert extends Component {
  render() {
    const style = {};
    style['color'] = '#FF6F00';

    return (
            this.props.error ? (
            <div>
              <span style={style}>{this.props.error}</span>
            </div>
            ) : null
    );
  }
}

ErrorAlert.propTypes = {
  error: PropTypes.string,
};
ErrorAlert.defaultProps = {};

export default ErrorAlert;
